module.exports = __webpack_public_path__ + "static/img/04.0aea515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/04.jpg
// module id = EqaE
// module chunks = 1